import React from "react";
import uniqueId from "lodash/uniqueId";
import Alert from "../Alert";

const ErrorList = ({ errors }) => {
  if (errors?.length) {
    return (
      <Alert
        className="error-list"
        type="error"
        title={
          <ul>
            {errors.map((errorItem) => (
              <li key={uniqueId("error_item_")}>{errorItem}</li>
            ))}
          </ul>
        }
      />
    );
  }

  return null;
};

export default ErrorList;
